import { useEffect } from "react";
import { api } from "@/lib/api";
import { applyAccent } from "@/lib/theme";
import { initAudioUnlock } from "@/lib/notify";

export default function ThemeInjector() {
  useEffect(() => {
    initAudioUnlock();
    api.get("/settings/storefront")
      .then((r) => applyAccent(r.data?.theme?.accent))
      .catch(() => {});
  }, []);
  return null;
}
